import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { canonicalUrl, routeMetaFor } from '../seo/routeMeta'

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

/**
 * Keeps <title>, description, canonical and robots in step with the route
 * after client-side navigation. The first page load already has them baked in
 * by scripts/prerender-routes.mjs.
 */
export function RouteHead() {
  const { pathname } = useLocation()

  useEffect(() => {
    const meta = routeMetaFor(pathname)
    document.title = meta.title
    upsertMeta('name', 'description', meta.description)
    upsertMeta('property', 'og:title', meta.title)
    upsertMeta('property', 'og:description', meta.description)
    upsertMeta('name', 'twitter:title', meta.title)
    upsertMeta('name', 'twitter:description', meta.description)
    upsertMeta('name', 'robots', meta.index ? 'index, follow' : 'noindex, follow')
    if (meta.index) {
      upsertCanonical(canonicalUrl(meta.path))
      upsertMeta('property', 'og:url', canonicalUrl(meta.path))
    } else {
      document.head.querySelector('link[rel="canonical"]')?.remove()
    }
  }, [pathname])

  return null
}
